<template>
    <div class="section">
        <b-tabs v-model="activeTab">
            <b-tab-item label="Tus ordenes">
                <Orders
                :orders="orders"
                :loading="loadingOrders"
                :count="count"
                :perPage="perPage"
                :page="page"
                :cartUrl="cartUrl"
                @pageChanged="onPageChange"/>
            </b-tab-item>
            <b-tab-item label="Perfil">
                <Perfil
                :profile="profile"
                :loading="loadingProfile"
                :btnLoading="updateProfileLoad"
                @updated="updatePerfil"
                />
            </b-tab-item>
            <b-tab-item label="Cambiar clave">
                <Password
                :passwordUrl="passwordUrl"/>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import Perfil from "./components/Perfil"
import Orders from "./components/Orders"
import Password from "./components/Password"
import { getHandler, patchHandler } from '../../../services/http'

export default {
    props:{
        profileUrl:{
            type:String,
            default:""
        },
        ordersUrl:{
            type:String,
            default:""
        },
        cartUrl:{
            type:String,
            default:""
        },
        passwordUrl:{
            type:String,
            default:""
        }
    },
    components:{
        Perfil, 
        Orders,
        Password
    },
    data(){
        return{
            activeTab:0,
            profile:{},
            loadingProfile:false,
            updateProfileLoad:false,

            orders:[],
            loadingOrders:false,
            count:0,
            perPage:24,
            page:1
        }
    },
    methods:{
        async fetchProfile(){
            this.loadingProfile=true
            this.profile = await getHandler(this.profileUrl, {error:false,success:false})
            this.loadingProfile=false
        },
        async updatePerfil(){
            var msgE={
                resources:"toast",
                text:"Algo salio mal, vuelve a intentarlo."
            }
            var msgS={
                resource:"toast",
                text:"Perfil actualizado."
            }
            this.updateProfileLoad=true
            
            let res = await patchHandler(this.profileUrl, this.profile, {
                error:msgE, success:msgS
            })

            this.updateProfileLoad=false
        },
        async fetchOrders(){
            this.loadingOrders = true
            let url = this.listUrl + "?page" + this.page
            let resp = await getHandler(this.ordersUrl, {error:false, success:false})
            console.log(resp)
            this.orders = resp.results
            this.count = resp.count
            this.loadingOrders = false
        },
        onPageChange(page){
            this.page = page
            this.fetchOrders()
        }
    },
    created(){
        this.fetchOrders()
        this.fetchProfile()
    }
}
</script>